import React from "react";

const Dashboard = () => {
    return (
        <h1>I am dashboard page</h1>
    );
}

export default Dashboard;